export default "__VITE_ASSET__C3y_xCIa__"